import { render, staticRenderFns } from "./PlatformSelectorInline.vue?vue&type=template&id=39a844b5"
import script from "./PlatformSelectorInline.vue?vue&type=script&lang=js"
export * from "./PlatformSelectorInline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports